import type { OrderServicePorts } from "../../model";
import { OrderEntity } from "../../model";

import type { Common } from "./ios";

import { EMPTY } from "~/shared/str";

function mapDtoToEntity({
  orderNumber,
  fromCity,
  fromAddress,
  fromFloor,
  fromPostalCode,
  fromBuildingType,
  fromBuildingArea,
  fromRoomCount,
  fromHasLift,
  fromHasAttic,
  fromHasBasement,
  toCity,
  toAddress,
  toFloor,
  toPostalCode,
  toBuildingType,
  toBuildingArea,
  toRoomCount,
  toHasLift,
  toHasAttic,
  toHasBasement,
  contactName,
  contactEmail,
  contactPhone,
  contactGender,
  isPaid,
  totalCost,
  totalPrice,
  services,
  createdDate,
  orderDateTime,
  whatToTransport,
  infoSource,
  infoSourceDetails,
  ...rest
}: Common.OutSchema): OrderServicePorts.ProviderIos.Common.Out {
  return {
    ...rest,
    number: orderNumber,
    from: {
      city: fromCity ?? EMPTY,
      address: fromAddress ?? EMPTY,
      floor: fromFloor,
      postalCode: fromPostalCode ?? EMPTY,
      buildingType: fromBuildingType,
      floorArea: fromBuildingArea,
      numberOfRooms: fromRoomCount,
      hasElevator: fromHasLift,
      hasAttic: fromHasAttic,
      hasBasement: fromHasBasement,
    },
    to: {
      city: toCity ?? EMPTY,
      address: toAddress ?? EMPTY,
      floor: toFloor,
      postalCode: toPostalCode ?? EMPTY,
      buildingType: toBuildingType,
      floorArea: toBuildingArea,
      numberOfRooms: toRoomCount,
      hasElevator: toHasLift,
      hasAttic: toHasAttic,
      hasBasement: toHasBasement,
    },
    cargoDescription: whatToTransport ?? EMPTY,
    referralInfo:
      infoSource === OrderEntity.ReferralSourceSchema.OTHER
        ? {
            source: infoSource,
            details: infoSourceDetails ?? EMPTY,
          }
        : {
            source: infoSource,
          },
    contactPerson: {
      fullName: contactName ?? EMPTY,
      email: contactEmail ?? EMPTY,
      phone: contactPhone ?? EMPTY,
      gender: contactGender,
    },
    payment: isPaid
      ? {
          isCompleted: isPaid,
          amount: totalCost,
        }
      : {
          isCompleted: isPaid,
        },
    cost: totalPrice,
    moveIsScheduledFor: new Date(orderDateTime),
    services: mapServices(services),
    createdAt: new Date(createdDate),
  };
}

function mapServices(
  services: Common.OutSchema["services"],
): OrderServicePorts.ProviderIos.Common.Out["services"] {
  return services.map(({ serviceId, serviceName, ...rest }) => ({
    ...rest,
    id: serviceId,
    name: serviceName,
  }));
}

function mapDtoToEntity2({
  orderNumber,
  isPaid,
  totalCost,
  totalPrice,
  createdDate,
  orderDateTime,
  contactName,
  fromAddress,
  toAddress,
  ...rest
}: Common.OutSchema2): OrderServicePorts.ProviderIos.GetMany.Out["items"][number] {
  return {
    ...rest,
    number: orderNumber,
    from: fromAddress ?? EMPTY,
    to: toAddress ?? EMPTY,
    contactPersonFullName: contactName ?? EMPTY,
    payment: isPaid
      ? {
          isCompleted: isPaid,
          amount: totalCost,
        }
      : {
          isCompleted: isPaid,
        },
    cost: totalPrice,
    createdAt: new Date(createdDate),
    moveIsScheduledFor: new Date(orderDateTime),
  };
}

export { mapDtoToEntity, mapDtoToEntity2, mapServices };
